import { NavLink } from 'react-router-dom'
import confirmDelete from 'shared/utils/confirmDelete'
import * as Icon from 'react-bootstrap-icons'
import getAll from 'utils/getAll'
import { apiUrls, roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import { getCustomData } from 'shared/components/App/Auth'
import ActionButtons from 'shared/components/ActionButtons'
import { IonIcon } from '@ionic/react'
import { lockOpenOutline } from 'ionicons/icons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
  unlockAccount: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.users)

  const isAdmin = hasAnyRole([roles.admin, roles.superAdmin])
  const currentUserId = getCustomData('userId')

  data.forEach((row: any, index: number, dataArray: any) => {
    if (isAdmin) {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'u',
              url: '/edit-user/' + row.id,
            },
            {
              type: 'p',
              id: dataArray[index].id,
              url: '/change-password/' + row.id,
            },
            {
              content: (
                <NavLink
                  to='#'
                  title='Unlock Account for Login'
                  onClick={(e) => {
                    props.unlockAccount(row.id)
                  }}
                >
                  <IonIcon
                    icon={lockOpenOutline}
                    className='ionicon'
                    style={{ fontSize: '16px' }}
                  />
                </NavLink>
              ),
            },
            {
              type: 'd',
              id: dataArray[index].id,
              url: '/delete-user/' + row.id,
              setDeleteEntryId: props.setDeleteEntryId,
              setShowModal: props.setShowModal,
            },
          ]}
        />
      )
    } else if (dataArray[index].id === currentUserId) {
      dataArray[index].action = (
        <ActionButtons
          buttons={[
            {
              type: 'u',
              url: '/edit-user/' + row.id,
            },
            {
              type: 'p',
              id: dataArray[index].id,
              url: '/change-password/' + row.id,
            },
          ]}
        />
      )
    }

    dataArray[index].email_reports = dataArray[index].email_reports === 1 ? 'Yes' : 'No'
  })

  return data
}

export default getRows
